import React, { useContext, useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router";
import { useParams } from "react-router-dom";
import API from "../Utility";
import {
  Row,
  Col,
  Button,
  Modal,
  Form,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";
import Table, { DefaultTableSettings } from "../Utility/Table";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import styled from "styled-components";
import { textColor } from "../Theme/Theme";
import { FaPlus, FaLock } from "react-icons/fa";
import Search from "../Search";
import Moment from "react-moment";
import ErrorModal from "../ErrorModal";
import { ProjectContext } from "../ProjectContext";
import ImportWorkflowFormModal from "./ImportWorkflowFormModal";

import variables from "../../variables.scss";

// Styles
import "./WorkflowsView.scss";

export default function WorkflowsView({ children, location, ...routeProps }) {
  // const { project } = useParams();
  const { project } = useContext(ProjectContext);
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalSize, setTotalSize] = useState(0);
  const [filter, setFilter] = useState({ ...DefaultTableSettings });
  const [isLoading, setIsLoading] = useState(false);
  const [createError, setCreateError] = useState(null);
  const [showImportWorkflowFormModal, setShowImportWorkflowFormModal] = useState();
  const [apiRunning, setApiRunning] = useState(false);
  const [initialised, setInitialised] = useState(false);

  async function getWorkflowsData({
    query = null,
    url,
    params = filter,
  }) {
    if (!apiRunning) {
      setApiRunning(true);
      setTableData([]);
      setIsLoading(true);
      params.nameMatch = query;
      setFilter(params);
      const { filteredResults, totalResultsCount } = await API.get({
        url: url,
        params: params,
      });
      setTableData(filteredResults);
      setTotalSize(totalResultsCount);
      setIsLoading(false);
      setApiRunning(false);
    }
  }

  async function initializeData(forceReload = false) {
    if ((!apiRunning && !initialised) || forceReload) {
      const workflowsUrl = `/admin/${project?._id}/workflows`;
      setInitialised(true);
      await getWorkflowsData({
        url: workflowsUrl,
        params: {
          page: DefaultTableSettings.page,
          pageSize: 20 // DefaultTableSettings.sizePerPage,
        },
      });
    }
  }

  useEffect(() => {
    if (project?._id && !apiRunning) {
      initializeData();
    }
  }, [project]);

  const columns = [
    {
      dataField: "name",
      text: "Name",
      width: "60%",
    },
    {
      dataField: "status",
      text: "Status",
      headerStyle: { textAlign: "left", width: "15%" },
      style: { textAlign: "left", width: "15%" },
      formatter: function callback(cell, row) {
        if (cell?.[0]) {
          return (
            <span>
              {" "}
              {cell[0].toUpperCase()}
              {cell.substring(1)}
            </span>
          );
        } else {
          return <></>;
        }
      },
    },
    {
      dataField: "created",
      text: "Date Created",
      headerStyle: { textAlign: "left", width: "25%" },
      style: { textAlign: "left", width: "25%" },
      formatter: function callback(cell, row) {
        if (cell) {
          return <Moment format="DD MMM 'YY">{cell}</Moment>;
        } else {
          return null;
        }

      },
    }
  ];

  const loading = () => {
    return tableData?.length < 1 && isLoading ? (
      <div>
        <Spinner animation="border" />
      </div>
    ) : (
      <div>
        <span>No results</span>
      </div>
    );
  };

  const onTableChange = async(type, { sortField, sortOrder, data, page }) => {
    setCurrentPage(page);
    await getWorkflowsData({
      params: {
        page: page,
        pageSize: 20,  // DefaultTableSettings.sizePerPage,
        sortType: sortField,
        sortDir: 1,
        nameMatch: null,
      },
    });
  };

  let history = useHistory();

  const rowClasses = "clickable react-bootstrap-table__row";

  const selectRow = {
    mode: "radio",
    style: {
      background: variables.pubhubPrimary,
      color: variables.pubhubPrimaryAlt,
    },
    clickToSelect: true,
    hideSelectColumn: true,
    onSelect: (row, isSelect, rowIndex, e) => {
      history.push(`/workflows/${project._id}/${row._id}`);
    },
  };

  const handleAddWorkflow = async() => {
    const response = await API.post({
      url: `/admin/${project._id}/workflows/create`
    });

    if (response?._id) {
      history.push(`/workflows/${project._id}/${response._id}/update`);
    } else {
      setCreateError(response?.message || "An error occurred");
    }
  };

  const onSuccessImportWorkflowFormModal = () => {
    setShowImportWorkflowFormModal(false);
    setInitialised(false);
    initializeData();
  };

  if (!project?._id) {
    return <></>;
  }

  return (
    <div className="workflows-list-view">
      <Row>
        <Col lg={6}>
          <h2>Workflows</h2>
        </Col>
        <Col lg={6}>
          <div className="workflows-list-view__search-form flex flex-row" style={{ marginBottom: '20px' }}>
            {/* <Search
              placeholder="Search"
              labelKey="name"
              options={tableData}
              isLoading={isLoading}
              isTypeAhead={false}
              minLength={3}
              delay={450}
              callback={(text) => {
                return getWorkflowsData({ query: text });
              }}
            /> */}
            {/* <Button
              onClick={() => {
                setShowCreateNewModal(true);
              }}
              variant="outline-primary"
            > */}
            {(project?.userPermissions?.isCurrentUserOwner || project?.userPermissions?.isCurrentUserAdmin || project?.userPermissions?.isWorkflowManager) &&
            <>
              <Button
                onClick={() => {
                  handleAddWorkflow();
                }}
                variant="outline-primary"
              >
                <FaPlus style={{ verticalAlign: "middle" }}></FaPlus>
                <span style={{ verticalAlign: "middle" }}> Add Workflow</span>
              </Button>
              <Button
                onClick={() => {
                  setShowImportWorkflowFormModal(true);
                }}
                variant="outline-primary"
                style={{ marginLeft: '10px' }}
              >
                <FaPlus style={{ verticalAlign: "middle" }}></FaPlus>
                <span style={{ verticalAlign: "middle" }}> Import Workflow</span>
              </Button>
            </>
            }
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Table
            remote
            columns={columns}
            keyField={'_id'}
            data={tableData}
            onTableChange={onTableChange}
            noDataIndication={loading}
            page={currentPage}
            totalSize={totalSize}
            selectRow={selectRow}
            rowClasses={rowClasses}
            sizePerPage={20}
          />
        </Col>
      </Row>

      {/* <CreateWorkflowFormModal
        show={showCreateNewModal}
        onCancel={() => {
          setShowCreateNewModal(false);
        }}
        onSuccess={createWorkflowFormModalOnSuccess}
      /> */}
      <ErrorModal
        title={`Error`}
        body={createError}
        show={createError?.length > 0}
        confirmtext="OK"
        onHide={() => setCreateError(null)}
      />
      <ImportWorkflowFormModal
        show={showImportWorkflowFormModal}
        onCancel={() => {
          setShowImportWorkflowFormModal(false);
        }}
        onSuccess={onSuccessImportWorkflowFormModal}
      />
    </div>
  );
}
